import { PageHeader } from "../../../components/typography/pageHeader";

export const UsersPage = () => {
  return (
    <div className="w-full">
      <PageHeader header={"Users"} className="font-unbounded font-normal" />
    </div>
  );
};
